import React from "react";
import classCompParent from "../imgs/classCompParent.png";
import classCompChild from "../imgs/classCompChild.png";
import classCompafterclicklog from "../imgs/classComp-after-click-log.png";
import classComppageloadlog from "../imgs/classComp-pageload-log.png";

export const LifeCycleLogs = () => {
  return (
    <div>
      Below are the screenshots and the basic references of Class Component lifecycle:
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginTop:"3rem",
          marginBottom: "2rem",
        }}
      >
        <div style={{ maxWidth: "40rem", marginRight: "1rem" }}>
          <p>Parent Component:</p>
          <img style={{ width: "40rem" }} src={classCompParent} />
        </div>

        <div>
          <p>Child Component:</p>
          <img style={{ width: "40rem" }} src={classCompChild} />
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", marginBottom: "2rem" }}>
        <div style={{ maxWidth: "40rem", marginRight: "1rem" }}>
          <p>Initial Page load logs:</p>
          <img style={{ width: "40rem" }} src={classComppageloadlog} />
        </div>

        <div>
          <p>After button Click logs:</p>
          <img style={{ width: "40rem" }} src={classCompafterclicklog} />
        </div>
      </div>
      <div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
